import React, { useState, useRef, useEffect, forwardRef } from 'react';
import {
  Image,
  Popover,
  Overlay,
  Form,
  Dropdown,
} from 'react-bootstrap';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { DatePicker } from 'antd';

import vectorRightIcon from '../../assets/images/customer_overview_vector.svg';
import alertIcon from '../../assets/images/alert.svg';
import SearchIcon from '../../assets/images/drop_down_filter.svg';
import closeIcon from '../../assets/images/close.svg';
import FilterIcon from '../../assets/images/alert_centre_filter_icon.svg';
import CustomTips from 'components/base/CustomTips';

import { createAction, debounce } from 'utils';
import { formatDate, TimeFormater } from 'utils/TimeFormatUtil';
import { ADMIN_ALERT_TYPE, ALERT_STATUS, DISPLAY_ADMIN_ALERT_TYPE } from 'config/CustomEnums';

import "./AlertCentre.scss"
import AuthButton from 'components/base/AuthButton';
import { ActionsDropdownForItem, ActionsForDowndownItem, CustomItemToggle } from 'components/base/ActionsDropdown';
import Loading from 'components/base/Loading';
import BasePrompt from 'components/base/prompt/BasePrompt';
import { CustomTitleLabel, CustomTitleWithRadio } from 'components/earning/CustomBaseComponments';
import ErrorFieldMessage from 'components/base/ErrorFieldMessage';


const mapPropsToState = (state) => ({
  isLoading: state.alertCentre.isLoadingList,
  hasNextPage: state.alertCentre.pageInfo.hasNextPage,
  unreadAlertCount: state.alertCentre.totalUnread,
  newestAlertTime: state.alertCentre.newestAlertTime,
  allAlerts: state.alertCentre.allAlerts,
});

const usePreviousValue = (value) => {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

const AlertCentre = ({
  isLoading,
  hasNextPage,
  newestAlertTime,
  unreadAlertCount,
  allAlerts,
}) => {
  const timeFilterType = {
    allTime: "All the time",
    inPeriod: "In a period",
  }
  const alertTimeSortType = {
    newestFirst: "Newest → Oldest",
    oldestFirst: "Oldest → Newest",
  }

  const dispatch = useDispatch();
  const alertCentreRef = useRef();
  const filterDatePickerRef = useRef();
  const alertScrollContainerRef = useRef();
  const prewScrollPosition = useRef();
  const alertScrollPosition = useRef();

  const previousAlertMaxTime = usePreviousValue(newestAlertTime);
  const [showAlertCentre, setShowAlertCentre] = useState(false);
  const [haveNewAlert, setHaveNewAlert] = useState(false);
  const [showNewAlertReminder, setShowNewAlertReminder] = useState(false);
  const [isLoadingMore, setIsLoadingMore] = useState();

  const [displaySearchBar, setDisplaySearchBar] = useState(true);
  const [showCompleteAllConfirmPrompt, setShowCompleteAllConfirmPrompt] = useState(false);
  const [showReadAllConfirmPrompt, setShowReadAllConfirmPrompt] = useState(false);

  const [showActions, setShowActions] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [search, setSearch] = useState();
  const [showFilterTimeSelector, setShowFilterTimeSelector] = useState();
  const [filterTimePeriod, setFilterTimePeriod] = useState([]);
  const [filterTimePeriodErrorMsg, setFilterTimePeriodErrorMsg] = useState("")
  const [sortAlertTime, setSortAlertTime] = useState("-creationDate");
  const [selectedQuickFilter, setSelectedQuickFilter] = useState("all")

  const quickFilterConfig = [
    { title: "All", key: "all" },
    { title: "To-do", key: ALERT_STATUS.INITIAL },
    { title: "Completed", key: ALERT_STATUS.COMPLETED },
  ]

  const closeAlertCentre = () => {
    closeAlertFilterPopup()
    setShowFilter(false)
    setShowActions(false)
    setDisplaySearchBar(true)
    setShowAlertCentre(false)
  }

  const clearAllFilterAndSearch = () => {
    setShowFilterTimeSelector(false)
    setFilterTimePeriod([])
    setSortAlertTime("-creationDate")
    setSearch("")
    setSelectedQuickFilter("all")
  }
  const queryNewestAlertTime = () => {
    if (isLoadingMore || isLoading) {
      return;
    }
    dispatch(createAction("alertCentre/getNewestAlertTime")());
  }
  const queryAlertList = ({
    isLoadMore,
  }) => {
    if (isLoadMore && sortAlertTime === "-creationDate" && !hasNextPage) {
      return
    }
    if (isLoadMore) {
      setIsLoadingMore(true)
    } else {
      setHaveNewAlert(false)
    }
    let searchDict = {
      search: search,
      afterAction: isLoadMore ? () => setIsLoadingMore(false) : (() => { }),
      isLoadMore,
    }
    if (showFilterTimeSelector && filterTimePeriod?.[0] && filterTimePeriod?.[1]) {
      searchDict["creationDateGte"] = formatDate(filterTimePeriod[0], TimeFormater.yearMonthDay)
      searchDict["creationDateLte"] = formatDate(filterTimePeriod[1], TimeFormater.yearMonthDay)
    }
    if (sortAlertTime) {
      searchDict["orderBy"] = sortAlertTime
    }
    if (selectedQuickFilter && selectedQuickFilter !== "all") {
      searchDict["statusIn"] = selectedQuickFilter
    }
    dispatch(createAction("alertCentre/getPagedAlertList")(
      searchDict,
    ));
  }

  const loadmoreAlerts = debounce(() => {
    if (isLoading) {
      return
    }
    queryAlertList({
      isLoadMore: true,
    })
  }, 500)

  const updateAlert = (alertInfo, updateBody) => {
    dispatch(createAction("alertCentre/updateAdminAlert")({
      id: alertInfo.pk,
      ...updateBody,
    }))
  }

  const updateAllAlertsStatus = (updateBody) => {
    dispatch(createAction("alertCentre/updateAllAdminAlerts")(updateBody))
  }

  const onSearch = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const searchKey = form.searchKey.value;
    setSearch(searchKey);
  };

  const marketAsRead = (alertInfo) => {
    if (alertInfo?.isRead) {
      return
    }
    updateAlert(alertInfo, { isRead: true, })
  }

  const quickFilterItems = () => {
    return quickFilterConfig?.map(item => (
      <div
        className={`quick-filter-item ${selectedQuickFilter === item?.key ? "selected" : ""}`}
        onClick={() => setSelectedQuickFilter(item?.key)}
      >
        {item?.title}
      </div>
    ))
  }
  const CustomGroupToggle = forwardRef(({ children, onClick }, ref) => (
    <div
      className='dropdown-for-item-toggle'
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      {children}
    </div>
  ));

  const closeAlertFilterPopup = () => {
    if (
      showFilterTimeSelector
      && (
        !filterTimePeriod?.[0]
        || !filterTimePeriod?.[1]
      )) {
      setShowFilterTimeSelector(false)
      setFilterTimePeriodErrorMsg("")
    }
  }

  const AlertFilterPopup = () => {
    return <Dropdown
      show={showFilter}
      drop={"down"}
      onToggle={(open) => {
        setShowFilter(open)
        if (!open) {
          closeAlertFilterPopup();
        }
      }}
      trigger={['click']}
    >
      <Dropdown.Toggle as={CustomGroupToggle}>
        <Image src={FilterIcon} />
      </Dropdown.Toggle>
      <Dropdown.Menu
        className="dropdown-for-item-menu alert-centre-filter-popup-content alert-centre-filter-popup-container"
        popperConfig={{}}
      >
        <CustomTitleLabel title={"FILTER"} className={"create-section-label-no-top-space"} />
        <CustomTitleWithRadio
          title={"Time period"}
          options={[
            {
              label: timeFilterType.allTime,
              value: timeFilterType.allTime,
            },
            {
              label: timeFilterType.inPeriod,
              value: timeFilterType.inPeriod,
            }
          ]}
          customTitleClass={"margin-top-16px"}
          optionsClassName={"flex-column flex-gap-12"}
          defaultValue={showFilterTimeSelector ? timeFilterType.inPeriod : timeFilterType.allTime}
          setValue={(value) => {
            if (value === timeFilterType.allTime) {
              setShowFilterTimeSelector(false)
              setFilterTimePeriod([])
              return
            }
            if (value === timeFilterType.inPeriod) {
              setShowFilterTimeSelector(true)
              return
            }
          }}
        />
        {showFilterTimeSelector ?
          <div
            ref={filterDatePickerRef}
            onMouseDown={e => e.preventDefault()}
          >
            <DatePicker.RangePicker
              getPopupContainer={() => filterDatePickerRef.current}
              value={[
                filterTimePeriod?.[0] || null,
                filterTimePeriod?.[1] || null,
              ]}
              className={"date-picker"}
              format={TimeFormater.dayMonthYearWeek}
              separator={"-"}
              onChange={(dates, dateStrings) => {
                filterTimePeriodErrorMsg && setFilterTimePeriodErrorMsg("")
                let [start, end] = dates || [];
                setFilterTimePeriod([start, end])
                if (!start || !end) {
                  setFilterTimePeriodErrorMsg("Please select the time period.")
                } else {
                  setFilterTimePeriodErrorMsg("")
                }
              }}
              onOpenChange={(open) => { }}
            />
            <ErrorFieldMessage
              error={Boolean(filterTimePeriodErrorMsg)}
              message={filterTimePeriodErrorMsg}
            />
          </div>
          : null
        }
        <Dropdown.Divider className="dropdown-for-item-divider" />
        <CustomTitleLabel title={"SORT"} className={"create-section-label-no-top-space"} />
        <CustomTitleWithRadio
          title={"Alert time"}
          options={[
            {
              label: alertTimeSortType.newestFirst,
              value: "-creationDate",
            },
            {
              label: alertTimeSortType.oldestFirst,
              value: "creationDate",
            }
          ]}
          customTitleClass={"margin-top-16px"}
          optionsClassName={"flex-column flex-gap-12"}
          defaultValue={sortAlertTime}
          setValue={(value) => setSortAlertTime(value)}
        />
      </Dropdown.Menu>
    </Dropdown>
  }

  const alertSearchBar = (
    <div className={`alert-search-bar ${displaySearchBar ? "" : "hide"}`}>
      <div className='alert-centre-filter-search'>
        <div className='d-flex flex-gap-4 width-100-percent'>
          <Form
            autoComplete="off"
            noValidate
            className={`list-filter-list-search-section width-100-percent`}
            onSubmit={onSearch}
          >
            <Image src={SearchIcon} className="list-filter-search-icon" />
            <input
              name="searchKey"
              defaultValue={search}
              type="text"
              className="list-filter-search-field"
              placeholder={"Search"}
            />
          </Form>
          <CustomTips
            customClass={{ area: '' }}
            detail={
              <div>
                {'Search by'}
                <ul style={{ paddingLeft: "1rem" }}>
                  <li>
                    {'Invoice ID'}
                  </li>
                  <li>
                    {'Transaction ID'}
                  </li>
                  <li>
                    {'Membership ID'}
                  </li>
                </ul>
              </div>
            }
            placement="bottom"
          />
        </div>
        <div className='d-flex'>
          <AlertFilterPopup />
          <Dropdown
            show={showActions}
            trigger={['click']}
            drop={"down"}
            onToggle={(open) => {
              setShowActions(open)
              if (open && showFilter) {
                setShowFilter(false)
                closeAlertFilterPopup()
              }
            }}
          >
            <Dropdown.Toggle as={CustomItemToggle} />
            <Dropdown.Menu
              className="dropdown-for-item-menu"
            >
              <ActionsForDowndownItem
                title="Actions"
                options={[
                  {
                    name: 'Mark all as complete',
                    action: () => {
                      setShowCompleteAllConfirmPrompt(true)
                    },
                  },
                  {
                    name: 'Mark all as read',
                    action: () => {
                      setShowReadAllConfirmPrompt(true)
                    },
                  },
                ]}
                object={{}}
              />
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className='alert-centre-filter-search'>
        {quickFilterItems()}
      </div>
    </div>
  )

  const getAlertLabel = (alertType) => {
    const displayAlertType = DISPLAY_ADMIN_ALERT_TYPE?.[alertType] || alertType
    return <div className='alert-label refund'>
      {displayAlertType || "-"}
    </div>
  }

  const AlertLinkableContent = ({ path, alertInfo, text, onClick, show }) => {
    if(!show) {
      return null
    }
    return (
      <Link
        to={path}
        onClick={() => {
          onClick && onClick(alertInfo)
          marketAsRead(alertInfo)
        }}
      >
        {text || '-'}
        <Image src={vectorRightIcon} style={{
          marginLeft: "4px",
          height: "16px",
          paddingTop: "4px",
          paddingBottom: "4px",
        }} />
      </Link>
    )
  }

  const getAlertReleasedRewardContent = (alertInfo) => {
    if (alertInfo?.alertType !== ADMIN_ALERT_TYPE.REWARD_LIMIT_RELEASED) {
      return null
    }
    let releasedReward = {}
    const releasedRewardStr = alertInfo?.reclaimedRewards
    if (typeof releasedRewardStr === 'string') {
      try {
        releasedReward = JSON.parse(releasedRewardStr);
      } catch (error) {
        console.error("Invalid JSON string:", error.message);
        return null
      }
    }
    const points = releasedReward?.points || 0
    const pp = releasedReward?.pp || 0
    const coupons = releasedReward?.coupons || 0
    const stamps = releasedReward?.stamps || 0

    return (
      <div className='d-flex flex-gap-4 flex-column'>
        <div className='alert-centre-reclaimed-reward-label'>{'Reclaimed rewards: '}</div>
        <AlertLinkableContent
          path={`/point_records?search=${alertInfo?.customer?.membershipId}`}
          alertInfo={alertInfo}
          text={`${points} point(s)`}
          show={!!points}
        />
        <AlertLinkableContent
          path={`/point_records?search=${alertInfo?.customer?.membershipId}`}
          alertInfo={alertInfo}
          text={`${pp} PP`}
          show={!!pp}
        />
        <AlertLinkableContent
          path={`/coupon_records?search=${alertInfo?.customer?.membershipId}`}
          alertInfo={alertInfo}
          text={`${coupons} coupon(s)`}
          show={!!coupons}
        />
        <AlertLinkableContent
          path={`/stamp_records?search=${alertInfo?.customer?.membershipId}`}
          alertInfo={alertInfo}
          text={`${stamps} stamp(s)`}
          show={!!stamps}
        />
      </div>
    )
  }

  const getAlertItemByType = (alertInfo) => {
    if ([
      ADMIN_ALERT_TYPE.TRANSACTION_REFUND,
      ADMIN_ALERT_TYPE.TRANSACTION_REFUND_UNDO_FAIL,
      ADMIN_ALERT_TYPE.REFUNDED_INVOICE_ID_NOT_FOUND,
      ADMIN_ALERT_TYPE.REPEATED_REFUND,
      ADMIN_ALERT_TYPE.REWARD_LIMIT_RELEASED,
      ADMIN_ALERT_TYPE.TRANSACTION_VALUE_LIMIT_RELEASED,
      ADMIN_ALERT_TYPE.STAMP_CAMPAIGN_NO_LONGER_VALID,
      ADMIN_ALERT_TYPE.RELATED_CAMPAIGN_CHANGED,
    ].includes(alertInfo?.alertType)) {
      return (
        <div className='alert-info-container'>
          <div className='d-flex alert-info-header' >
            <div className='d-flex' style={{ alignItems: "center" }}>
              {!alertInfo?.isRead ? <div className='red-dot' /> : null}
              <div>{`ID: ${alertInfo?.pk || "-"}`}</div>
            </div>
            <div>
              {formatDate(alertInfo?.creationDate, 'DD MMM yyyy, HH:mm')}
            </div>
          </div>
          <div className='d-flex flex-column flex-gap-8'>
            {getAlertLabel(alertInfo?.alertType)}
            <div className={`alert-transaction-description ${alertInfo?.isRead && alertInfo?.status === ALERT_STATUS.COMPLETED
                ? 'dimmed' : ""
              }`}>
              {alertInfo?.description || "This transaction requires your further actions."}
            </div>
            <div className='d-flex flex-gap-8'>
              <div className='alert-small-card'>
                <div className='d-flex flex-gap-4 flex-column'>
                  <div className='card-title'>{'Transaction ID:'}</div>
                  <Link
                    to={`/transactions/${alertInfo?.transaction?.pk}/`}
                    onClick={() => {
                      marketAsRead(alertInfo)
                    }}
                  >
                    {alertInfo?.transaction?.pk || '-'}
                    <Image src={vectorRightIcon} style={{
                      marginLeft: "4px",
                      height: "8px"
                    }} />
                  </Link>
                </div>
                {alertInfo?.originalTransaction?.pk ? <div className='d-flex flex-gap-4 flex-column'>
                  <div className='card-title'>{'Original transaction ID: '}</div>
                  <Link
                    to={`/transactions/${alertInfo?.originalTransaction?.pk}/`}
                    onClick={() => {
                      marketAsRead(alertInfo)
                    }}
                  >
                    {alertInfo?.originalTransaction?.pk || '-'}
                    <Image src={vectorRightIcon} style={{
                      marginLeft: "4px",
                      height: "8px"
                    }} />
                  </Link>
                </div> : null}
                {getAlertReleasedRewardContent(alertInfo)}
              </div>
              <div className='alert-small-card'>
                <div className='d-flex flex-gap-4 flex-column'>
                  <div className='card-title'>{'Member ID:'}</div>
                  {
                    alertInfo?.customerIsRestricted
                    ? <span>{alertInfo?.customer?.membershipId || '-'}</span>
                    : <Link
                      to={`/customers/${alertInfo?.customer?.pk}/`}
                      onClick={() => {
                        marketAsRead(alertInfo)
                      }}
                    >
                      {alertInfo?.customer?.membershipId || '-'}
                      <Image src={vectorRightIcon} style={{
                        marginLeft: "4px",
                        height: "8px"
                      }} />
                    </Link>
                  }
                </div>
              </div>
            </div>
          </div>
          {alertInfo?.status === ALERT_STATUS.COMPLETED
            ? <div className='alert-card-action'>
              {"Completed"}
              <ActionsDropdownForItem
                dropPosition="down"
                actions={[
                  {
                    name: 'Mark as to-do',
                    action: (alertInfo) => {
                      updateAlert(alertInfo, { status: ALERT_STATUS.INITIAL, })
                    },
                  },
                ]}
                object={alertInfo}
              />
            </div>
            :
            <div className='alert-card-action'>
              <AuthButton
                customClass="btn-back-button-common btn-download"
                title="Complete"
                action={() => {
                  updateAlert(alertInfo, { status: ALERT_STATUS.COMPLETED, })
                }}
              />
            </div>}
        </div>
      );
    }
  }

  useEffect(() => {
    if (!showFilterTimeSelector) {
      queryAlertList({})
      setFilterTimePeriodErrorMsg("")
      return
    }
    if (showFilterTimeSelector
      && filterTimePeriod?.[0]
      && filterTimePeriod?.[1]
    ) {
      queryAlertList({})
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    showFilterTimeSelector,
    filterTimePeriod,
  ])

  useEffect(() => {
    queryAlertList({})
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, selectedQuickFilter, sortAlertTime])

  useEffect(() => {
    if (showAlertCentre) {
      setDisplaySearchBar(true)
      setShowNewAlertReminder(haveNewAlert)
      queryNewestAlertTime()
    }
    if (showAlertCentre && alertScrollPosition.current && alertScrollContainerRef.current) {
      alertScrollContainerRef.current.scrollTop = alertScrollPosition.current
      return
    }
    alertScrollPosition.current = alertScrollContainerRef.current ? alertScrollContainerRef.current.scrollTop || 0 : 0
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showAlertCentre])

  useEffect(() => {
    setShowNewAlertReminder(haveNewAlert)
  }, [haveNewAlert])

  useEffect(() => {
    if (previousAlertMaxTime !== undefined
      && newestAlertTime
      && previousAlertMaxTime !== newestAlertTime
    ) {
      setHaveNewAlert(true)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newestAlertTime])

  useEffect(() => {
    const interval = setInterval(() => {
      console.log('This will run every 2 mins!');
      queryNewestAlertTime()
    }, 1000 * 60 * 2);
    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  return (
    <>
      <button
        className="system-task-area"
        ref={alertCentreRef}
        onClick={() => {
          setShowAlertCentre(true)
        }}
      >
        <Image src={alertIcon} className="download-icon" />
        <label className="header-text">{"Alert centre"}</label>
        {unreadAlertCount ? (
          <label className="badge-icon">{unreadAlertCount}</label>
        ) : null}
      </button>
      <Overlay
        target={alertCentreRef.current}
        show={showAlertCentre}
        placement="bottom"
        rootClose
        onHide={closeAlertCentre}
      >
        {(props) => (
          <div
            {...props}
            className="overlay-trigger alert-centre-overlay-trigger"
            style={{
              padding: '2px 10px',
              color: 'white',
              borderRadius: 3,
              ...props.style,
              zIndex: 3,
              height: 'calc(100vh - 65px)',
              marginLeft: "-290px"
            }}
          >
            <Popover
              id={`alert_centre_popover`}
              style={{}}
              arrowProps={null}
              bsClass="alertCentrePopover"
            >
              <Popover.Title>
                <div className="system-task-header">
                  <label className="system-task center-system-task-title">
                    {"Alert centre"}
                  </label>
                  <button
                    className="custom-image-button margin-left-auto"
                    onClick={closeAlertCentre}
                  >
                    <Image src={closeIcon} className="system-task-close" />
                  </button>
                </div>
              </Popover.Title>
              <Popover.Content style={{ height: "100%", overflowY: "hidden" }}>
                {alertSearchBar}
                <div
                  className={`alert-search-bar ${displaySearchBar ? "" : "alert-centre-hide-search-bar"}`}
                >
                  {showNewAlertReminder ? (
                    <div className="have-new-alert-reminder">
                      <div>
                        {"You have new alerts."}
                      </div>
                      <div className='d-flex flex-gap-12'>
                        <div className='refresh-alert-button' onClick={clearAllFilterAndSearch}>
                          {"View now"}
                        </div>
                        <Image
                          src={closeIcon}
                          onClick={() => setShowNewAlertReminder(false)}
                        />
                      </div>
                    </div>)
                    : null
                  }
                  {isLoading ? <Loading /> :
                    allAlerts?.length > 0 ? (
                      <PerfectScrollbar
                        onScroll={(e) => {
                          const { scrollTop, scrollHeight, clientHeight } = e.target;
                          if (prewScrollPosition.current && scrollTop - prewScrollPosition.current > 0) {
                            !showFilter && !showActions && displaySearchBar && setDisplaySearchBar(false)
                          } else if (prewScrollPosition.current && prewScrollPosition.current - scrollTop > 0) {
                            !displaySearchBar && setDisplaySearchBar(true)
                          }
                          if (scrollTop + clientHeight === scrollHeight) {
                            loadmoreAlerts()
                          }
                          prewScrollPosition.current = scrollTop
                        }}
                      >
                        <div
                          ref={alertScrollContainerRef}
                          className={`system-task-content ${displaySearchBar ? "" : "alert-centre-hide-search-bar"} ${showNewAlertReminder ? "show-reminder" : ""}`}
                        >
                          {allAlerts.map((item, index) => {
                            return getAlertItemByType(item)
                          })}
                          {isLoadingMore ? <div className='alert-info-container'><Loading /></div> : null}
                        </div>
                      </PerfectScrollbar>
                    ) : null
                  }
                </div>
              </Popover.Content>
            </Popover>
          </div>
        )}
      </Overlay>
      <BasePrompt
        customClass={'export-report-modal'}
        show={showCompleteAllConfirmPrompt}
        closeAction={() => setShowCompleteAllConfirmPrompt(false)}
        title={"Reminder"}
        description={"Confirm to mark all alert as completed?"}
        leftButton={{
          text: 'Cancel',
          action: () => {
            setShowCompleteAllConfirmPrompt(false)
          },
        }}
        rightButton={{
          text: 'Confirm',
          action: () => {
            updateAllAlertsStatus({ status: ALERT_STATUS.COMPLETED })
            setShowCompleteAllConfirmPrompt(false)
          },
        }}
      />
      <BasePrompt
        customClass={'export-report-modal'}
        show={showReadAllConfirmPrompt}
        closeAction={() => setShowReadAllConfirmPrompt(false)}
        title={"Reminder"}
        description={"Confirm to mark all alert as read?"}
        leftButton={{
          text: 'Cancel',
          action: () => {
            setShowReadAllConfirmPrompt(false)
          },
        }}
        rightButton={{
          text: 'Confirm',
          action: () => {
            updateAllAlertsStatus({ isRead: true })
            setShowReadAllConfirmPrompt(false)
          },
        }}
      />
    </>)
}

export default connect(mapPropsToState)(AlertCentre);
